'use client'

import UISlideTab, { UISlideTabProps } from '@components/ui/UITab'
import { Box } from '@mui/joy'
import { theme } from '@ui/style'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import IssueHeader, { IssueHeaderProps } from '@page/article/_components/common/IssueHeader'
import { useState } from 'react'

interface TopicHeaderProps
	extends Pick<IssueHeaderProps, 'title' | 'href' | 'bgImg'>,
		Pick<UISlideTabProps, 'options'> {
	packageIdx?: string
	bgcolor?: string
}
const TopicHeader = ({ title, href, bgImg, options, packageIdx, bgcolor }: TopicHeaderProps) => {
	const [current, setCurrent] = useState<string | number | undefined>(packageIdx)
	return (
		<Box className="print-hide">
			<IssueHeader
				title={title}
				href={href}
				bgImg={bgImg}
				bgcolor={bgcolor}
				sx={{
					display: { xs: 'none', lg: 'flex' },
				}}
			/>
			<UISlideTab
				link
				size="lg"
				options={options}
				current={current}
				setCurrent={(value) => setCurrent(value)}
				sx={{
					[theme.breakpoints.down('lg')]: {
						background: color.colGray1,
						borderBottom: `1px solid ${color.colGray3}`,
						borderTop: `1px solid ${color.colGray3}`,
						'.swiper-slide': {
							'&:first-child': {
								paddingRight: `${pxToRem(16)}!important`,
								'&::after': {
									content: '""',
									display: 'block',
									width: '1px',
									height: pxToRem(24),
									background: color.colGray3,
									position: 'absolute',
									top: '50%',
									right: pxToRem(4),
									marginTop: pxToRem(-12),
								},
								'&>a': {
									paddingX: 0,
									color: color.colDarkBlue,
									pointerEvents: 'none',
								},
							},
							'&:not(:last-child)': {
								paddingRight: pxToRem(8),
							},
							'&>a': {
								fontSize: pxToRem(16),
								lineHeight: pxToRem(24),
								padding: `${pxToRem(16)} ${pxToRem(8)}`,
								border: `0!important`,
								'&:hover': {
									border: `0!important`,
								},
								'&[aria-selected="true"]': {
									border: `0!important`,
									color: color.colBlack,
								},
							},
						},
						'.swiper-button-prev, .swiper-button-next': {
							display: 'none',
						},
					},
					[theme.breakpoints.up('lg')]: {
						'.swiper-slide:first-child': {
							display: 'none',
						},
					},
				}}
			/>
		</Box>
	)
}

export default TopicHeader
